import React from 'react'

import { Logo } from 'components/Header'
import LogoImg from 'i/talkpro_logo_white.png'
import { ReactComponent as InfoIcon } from 'i/icons/info.svg';

const HeaderProfile = (props) => {
  // const headerRef = useRef(null)
  const menuHandler = (e) => {
    e.target.classList.toggle('menu_trigger--active_mod')
    document.querySelector('.header_menu').classList.toggle('header_menu--active')
    document.body.classList.toggle('body--menu_open')
  }

  const menuList = ['About', 'Billing', 'Logout']

  return (
    <header
      className={`header profile_mod ${
        props.isBookPage || props.isConfirmPage ? 'short_mod' : ''
      }`}
      // ref={headerRef}
    >
      <div className="header_in qq">
        <div className="header_logo_w_block">
          <div className="header_logo_w_block_in">
            <div className="header_logo_w profile_mod">
              <Logo />
            </div>
          </div>
        </div>
        <div className="header_btn">
           <a href="https://join.talkpro.com/" target="_blank" className="header_icon" rel="noreferrer">
           <InfoIcon className="icon size_mod" />
          </a>
          <a href="/" className="header_btn__link">
            About TalkPro
          </a>
        </div>
        {/* <a href="#" className="header_back">
					<BackIcon className='icon size_mod' />
				</a> */}
        {!props.isBookPage && !props.isConfirmPage ? (
          <div className="menu_trigger profile_mod" onClick={menuHandler}>
            <div className="menu_trigger__block">
              <span className="menu_trigger_decor"></span>
            </div>
          </div>
        ) : null}
        <div className="header_menu">
          <div className="header_menu__list">
            {menuList.map((item, index) => {
              return (
                <div className="header_menu__item" key={index}>
                  <a href="/" className="header_menu__link">
                    {item}
                  </a>
                </div>
              )
            })}
          </div>
          <div className="header_menu__logo">
            <img className="header_menu__logo_img" src={LogoImg} alt="" />
          </div>
        </div>
      </div>
    </header>
  )
}

export default HeaderProfile
